import { Box, Button } from "@mui/material";
import { prepareEmbedUrl } from "../../utils/common";
import { useState, useEffect } from "react";
import { useTimeoutHit } from "../../hooks/useTimeoutHit";

const GoogleDocPDFViewer = ({ url, onLoad, onError, iframeStyle = {} }) => {
  const [loaded, setLoaded] = useState(false);
  const { timeoutHit, resetTimeoutHit } = useTimeoutHit(5000);
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
    setLoaded(false);
    resetTimeoutHit();
  }, [url]);

  const handleOnLoad = () => {
    setLoaded(true);
    if (onLoad) {
      onLoad();
    }
  }

  const handleOnError = () => {
    setError(true);
    if (onError) {
      onError();
    }
  }

  const showReloadButton = (timeoutHit && !loaded) || error;
  return (
    <Box style={{ height: '100%', width: '100%' }}>
      {showReloadButton && (
        <Box mt={1} textAlign="center">
          <Button onClick={() => window.location.reload()} variant="outlined" disableElevation color="error">
            Reload
          </Button>
        </Box>
      )}
      <iframe
        width="100%" height="100%"
        src={prepareEmbedUrl((url), 'google-docs')}
        style={{ border: 'none', height: '100%', width: '100%', ...iframeStyle }}
        allowFullScreen
        onLoad={handleOnLoad}
        onError={handleOnError}
        title="PDF Document"
      />
    </Box>
  );
};

export default GoogleDocPDFViewer;